import styled, { keyframes } from 'styled-components';

const moveEllipse1 = keyframes`
    0% {
        transform: translate(0px, 0px) rotate(0deg) scale(1);
        border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    }
    25% {
        transform: translate(65px, -50px) rotate(90deg) scale(1.15);
        border-radius: 40% 60% 70% 30% / 50% 60% 40% 50%;
    }
    50% {
        transform: translate(-45px, 55px) rotate(180deg) scale(0.92);
        border-radius: 70% 30% 50% 50% / 30% 70% 30% 70%;
    }
    75% {
        transform: translate(50px, 40px) rotate(270deg) scale(1.1);
        border-radius: 35% 65% 40% 60% / 65% 35% 60% 40%;
    }
    100% {
        transform: translate(0px, 0px) rotate(360deg) scale(1);
        border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    }
`;

const moveEllipse2 = keyframes`
    0% {
        transform: translate(0px, 0px) rotate(0deg) scale(1);
        border-radius: 50% 50% 60% 40% / 40% 60% 40% 60%;
    }
    30% {
        transform: translate(-75px, -40px) rotate(-110deg) scale(1.18);
        border-radius: 30% 70% 40% 60% / 60% 40% 60% 40%;
    }
    60% {
        transform: translate(55px, -55px) rotate(-220deg) scale(0.88);
        border-radius: 65% 35% 60% 40% / 35% 65% 35% 65%;
    }
    85% {
        transform: translate(-35px, 45px) rotate(-300deg) scale(1.06);
        border-radius: 45% 55% 35% 65% / 55% 45% 65% 35%;
    }
    100% {
        transform: translate(0px, 0px) rotate(-360deg) scale(1);
        border-radius: 50% 50% 60% 40% / 40% 60% 40% 60%;
    }
`;

const moveEllipse3 = keyframes`
    0% {
        transform: translate(0px, 0px) rotate(0deg) scale(0.95);
        border-radius: 40% 60% 50% 50% / 60% 30% 70% 40%;
    }
    33% {
        transform: translate(55px, 65px) rotate(120deg) scale(1.2);
        border-radius: 70% 30% 60% 40% / 40% 70% 30% 60%;
    }
    66% {
        transform: translate(-65px, -35px) rotate(240deg) scale(0.9);
        border-radius: 30% 70% 30% 70% / 70% 40% 60% 30%;
    }
    100% {
        transform: translate(0px, 0px) rotate(360deg) scale(0.95);
        border-radius: 40% 60% 50% 50% / 60% 30% 70% 40%;
    }
`;

const moveEllipse4 = keyframes`
    0% {
        transform: translate(0px, 0px) rotate(0deg) scale(1);
        border-radius: 55% 45% 40% 60% / 50% 50% 50% 50%;
    }
    25% {
        transform: translate(-50px, 60px) rotate(-90deg) scale(0.85);
        border-radius: 35% 65% 60% 40% / 40% 60% 40% 60%;
    }
    50% {
        transform: translate(65px, 25px) rotate(-180deg) scale(1.14);
        border-radius: 60% 40% 35% 65% / 65% 35% 65% 35%;
    }
    75% {
        transform: translate(-35px, -50px) rotate(-270deg) scale(0.94);
        border-radius: 40% 60% 55% 45% / 35% 65% 45% 55%;
    }
    100% {
        transform: translate(0px, 0px) rotate(-360deg) scale(1);
        border-radius: 55% 45% 40% 60% / 50% 50% 50% 50%;
    }
`;

const moveEllipse5 = keyframes`
    0% {
        transform: translate(0px, 0px) rotate(0deg) scale(0.9);
        border-radius: 45% 55% 65% 35% / 45% 55% 45% 55%;
    }
    50% {
        transform: translate(-40px, -40px) rotate(180deg) scale(1.22);
        border-radius: 65% 35% 40% 60% / 55% 45% 60% 40%;
    }
    100% {
        transform: translate(0px, 0px) rotate(360deg) scale(0.9);
        border-radius: 45% 55% 65% 35% / 45% 55% 45% 55%;
    }
`;

export const LoaderWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    z-index: 10;
    overflow: hidden;
    pointer-events: none;
`;

export const EllipsesStage = styled.div`
    position: relative;
    width: 320px;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 768px) {
        width: 460px;
        height: 460px;
    }
`;

export const EllipseOne = styled.div`
    position: absolute;
    width: 260px;
    height: 260px;
    background: ${({ $color }) => $color};
    filter: blur(40px);
    opacity: 0.8;
    will-change: transform, border-radius;
    animation: ${moveEllipse1} 9s ease-in-out infinite;

    @media (min-width: 768px) {
        width: 340px;
        height: 340px;
        filter: blur(55px);
    }
`;

export const EllipseTwo = styled.div`
    position: absolute;
    width: 240px;
    height: 240px;
    background: ${({ $color }) => $color};
    filter: blur(35px);
    opacity: 0.75;
    will-change: transform, border-radius;
    animation: ${moveEllipse2} 11s ease-in-out infinite;

    @media (min-width: 768px) {
        width: 310px;
        height: 310px;
        filter: blur(50px);
    }
`;

export const EllipseThree = styled.div`
    position: absolute;
    width: 220px;
    height: 220px;
    background: ${({ $color }) => $color};
    filter: blur(32px);
    opacity: 0.7;
    will-change: transform, border-radius;
    animation: ${moveEllipse3} 8s ease-in-out infinite;

    @media (min-width: 768px) {
        width: 290px;
        height: 290px;
        filter: blur(45px);
    }
`;

export const EllipseFour = styled.div`
    position: absolute;
    width: 200px;
    height: 200px;
    background: ${({ $color }) => $color};
    filter: blur(28px);
    opacity: 0.65;
    will-change: transform, border-radius;
    animation: ${moveEllipse4} 13s ease-in-out infinite;

    @media (min-width: 768px) {
        width: 260px;
        height: 260px;
        filter: blur(40px);
    }
`;

export const EllipseFive = styled.div`
    position: absolute;
    width: 170px;
    height: 170px;
    background: ${({ $color }) => $color};
    filter: blur(24px);
    opacity: 0.6;
    will-change: transform, border-radius;
    animation: ${moveEllipse5} 7s ease-in-out infinite;

    @media (min-width: 768px) {
        width: 220px;
        height: 220px;
        filter: blur(35px);
    }
`;
